import api from './apiClient';
import type { ApiResponse } from 'shared/types/api';

export interface PlatformModulesSettings {
  marketplace: boolean;
  workPermits: boolean;
}

export interface PlatformSettings {
  modules: PlatformModulesSettings;
  updatedAt?: string;
}

export const platformSettingsApi = {
  get: async (): Promise<PlatformSettings> => {
    const res = await api.get<ApiResponse<PlatformSettings>>('/platform-settings');
    return res.data || { modules: { marketplace: true, workPermits: true } };
  },
  update: async (changes: Partial<PlatformModulesSettings>): Promise<PlatformSettings> => {
    const res = await api.patch<ApiResponse<PlatformSettings>>('/platform-settings', changes);
    return res.data || { modules: { marketplace: true, workPermits: true } };
  },
};
